import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-085204a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside-progress" }
const _hoisted_2 = { class: "aside-progress__image-wrapper" }
const _hoisted_3 = { class: "aside-progress-mask__list" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "aside-progress__bar-indicator" }

import InterviewProgressIndicator from '@/components/Icons/InterviewProgressIndicator.vue'
import { useInterviewStore } from '@/stores/interviewStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'InterviewProgress',
  props: {
    progress: null
  },
  setup(__props: any) {


const store = useInterviewStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).progressMasks, (mask, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: index,
            src: mask,
            class: "aside-progress-mask__item-image",
            alt: ""
          }, null, 8, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("img", {
        class: "aside-progress__image aside-progress__image--lg",
        src: _unref(store).sidebarImages?.SideBarImageDesktop?.Url,
        alt: _unref(store).sidebarImages?.SideBarImageDesktop?.Alt
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        class: "aside-progress__image aside-progress__image--sm",
        src: _unref(store).sidebarImages?.SideBarImageMobile?.Url,
        alt: _unref(store).sidebarImages?.SideBarImageMobile?.Alt
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", {
      class: "aside-progress__bar",
      style: _normalizeStyle(`--progress: ${ __props.progress }%`)
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(InterviewProgressIndicator)
      ])
    ], 4)
  ]))
}
}

})